// Opções de "Onde" (contrato ou centro de custo), no mesmo agrupamento em
// toda tela de horas: os meus contratos primeiro, o backoffice, e o resto.
import type { CentroCustoOpc, ContratoOpc } from './api';

type Atual = { contrato_id?: string | null; centro_custo_codigo?: string | null; rotulo_destino?: string | null } | null | undefined;

export function montarOpcoesDestino(
  contratos: Pick<ContratoOpc, 'id' | 'numero' | 'titulo' | 'meu'>[], ccs: CentroCustoOpc[], atual?: Atual,
) {
  const grupos = [
    {
      label: 'Meus contratos',
      options: contratos.filter(c => c.meu).map(c => ({ value: `c:${c.id}`, label: `${c.numero} — ${c.titulo}` })),
    },
    {
      label: 'Não é projeto',
      options: ccs.map(c => ({ value: `e:${c.codigo_canonical}`, label: c.nome_completo })),
    },
    {
      label: 'Outros contratos',
      options: contratos.filter(c => !c.meu).map(c => ({ value: `c:${c.id}`, label: `${c.numero} — ${c.titulo}` })),
    },
  ];
  // O destino gravado pode não estar nas listas (centro de custo desativado,
  // contrato fora da busca): entra como opção própria, senão o campo
  // apareceria com um código cru — ou vazio — na correção.
  const chave = atual?.contrato_id ? `c:${atual.contrato_id}` : atual?.centro_custo_codigo ? `e:${atual.centro_custo_codigo}` : null;
  if (chave && !grupos.some(g => g.options.some(o => o.value === chave))) {
    grupos.unshift({ label: 'Deste lançamento', options: [{ value: chave, label: atual?.rotulo_destino || chave.slice(2) }] });
  }
  return grupos.filter(g => g.options.length > 0);
}

// Busca por escrita nos destinos (DestinoCampo do atalho): acento e maiúscula
// não importam, e cada palavra digitada tem que aparecer no rótulo
// ("hy 060", "portal cons").
export type OpcaoDestino = { value: string; label: string };
export type GrupoDestino = { label: string; options: OpcaoDestino[] };

const normal = (s: string) => s.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

export function filtrarDestinos(grupos: GrupoDestino[], termo: string): GrupoDestino[] {
  const partes = normal(termo).split(/\s+/).filter(Boolean);
  if (!partes.length) return grupos;
  return grupos
    .map(g => ({ ...g, options: g.options.filter(o => { const n = normal(o.label); return partes.every(p => n.includes(p)); }) }))
    .filter(g => g.options.length > 0);
}
